"use client";

import { useEffect, useState } from "react";
import styles from "./page.module.css";

const LANG_KEY = "vtob_lang";

const copy = {
  de: {
    desc: "Interner Workspace fuer Vision zu Businessplan. Sprachen: Deutsch und Englisch.",
    idea: "Idee erfassen",
    generate: "Plan generieren",
    projects: "Projekte ansehen",
  },
  en: {
    desc: "Internal workspace for Vision to Business Plan. Languages: German and English.",
    idea: "Capture idea",
    generate: "Generate plan",
    projects: "View projects",
  },
} as const;

export default function Home() {
  const [lang, setLang] = useState<"de" | "en">("de");

  useEffect(() => {
    const current = window.localStorage.getItem(LANG_KEY) === "en" ? "en" : "de";
    setLang(current);
    const handler = (ev: Event) => {
      const detail = (ev as CustomEvent).detail;
      setLang(detail === "en" ? "en" : "de");
    };
    window.addEventListener("vtob-lang-change", handler);
    return () => window.removeEventListener("vtob-lang-change", handler);
  }, []);

  const t = copy[lang];

  return (
    <div className={styles.page}>
      <main className={styles.main}>
        <div className={styles.intro}>
          <h1>vtob_fin@healthcare</h1>
          <p>{t.desc}</p>
        </div>
        <div className={styles.ctas}>
          <a className={styles.primary} href="/idee-erfassen">
            {t.idea}
          </a>
          <a className={styles.secondary} href="/plan-generieren">
            {t.generate}
          </a>
          <a className={styles.secondary} href="/projekte">
            {t.projects}
          </a>
        </div>
      </main>
    </div>
  );
}
